export default "__VITE_ASSET__CmoPOeie__"